import { Button, Col, Row } from "react-bootstrap";

interface Props {
  currentPage: number;
  lastPage: number;
  total: number;
  perPage: number;
  onPageChange: (page: number) => void;
}

export const SimplePagination = ({ 
  currentPage, 
  lastPage, 
  total, 
  perPage, 
  onPageChange 
}: Props) => {
  const startItem = (currentPage - 1) * perPage + 1;
  const endItem = Math.min(currentPage * perPage, total);

  return (
    <Row className="align-items-center mt-3">
      <Col>
        <span className="text-muted">
          Mostrando {startItem} a {endItem} de {total} unidades
        </span>
      </Col>
      <Col xs="auto">
        <Button
          variant="outline-primary"
          size="sm"
          disabled={currentPage === 1}
          onClick={() => onPageChange(currentPage - 1)}
        >
          Anterior
        </Button>
        <span className="mx-2">
          Página {currentPage} de {lastPage}
        </span>
        <Button
          variant="outline-primary"
          size="sm"
          disabled={currentPage === lastPage}
          onClick={() => onPageChange(currentPage + 1)}
        >
          Siguiente
        </Button>
      </Col>
    </Row>
  );
};
